import { Component } from '@angular/core'
import { LanguageService, Locale } from '../../../services/language.service'

@Component({
  selector: 'language-switch',
  templateUrl: './language.component.html',
  styleUrl: './language.component.css'
})
export class LanguageSwitch {
  currentLocale
  localeEN = Locale.EN
  localeCN = Locale.ZH_CN
  localeHK = Locale.ZH_HK

  constructor(private langService: LanguageService) {
    this.currentLocale = this.langService.getCurrentLocale()
  }

  onLangPicked(locale: Locale) {
    if (this.currentLocale === locale) {
      return
    }

    this.currentLocale = locale
    this.langService.setLangWithLocale(locale)
  }
}
